import {
	AttachmentStatus,
	AttachmentType,
	type FileAttachment as FileAttachmentType,
} from '@/utils/fetchers/attachment'
import clsx from 'clsx'
import {
	type HTMLAttributes,
	type MouseEventHandler,
	type ReactElement,
	type Ref,
	type RefObject,
} from 'react'
import ClickWrapper from '../ClickWrapper'
import Attachment from './Attachment'
import styles from './FileAttachment.module.css'

export type FileAttachmentElement = HTMLImageElement | HTMLVideoElement
export interface FileAttachmentProps extends HTMLAttributes<
	HTMLImageElement | HTMLVideoElement | HTMLDivElement
> {
	data: FileAttachmentType
	onDelete?: () => void
	onRetry?: () => void
	ref?: Ref<FileAttachmentElement>
}

export default function FileAttachment({
	data,
	onDelete,
	onClick,
	onRetry,
	ref,
	className,
	...props
}: FileAttachmentProps) {
	const status = data.status

	let content: ReactElement | null = null
	const src = !data.file?.size ? data.cdn?.file.fileUrl : URL.createObjectURL(data.file)

	if (!src) {
		return null
	}
	switch (data.type) {
		case AttachmentType.PICTURE:
			content = (
				<img
					ref={ref as RefObject<HTMLImageElement>}
					src={src}
					className={clsx(styles.image, className)}
					{...(props as HTMLAttributes<HTMLImageElement>)}
				/>
			)
			break
		case AttachmentType.VIDEO:
			content = (
				<video
					src={src}
					muted
					ref={ref as RefObject<HTMLVideoElement>}
					className={clsx(styles.video, className)}
					{...(props as HTMLAttributes<HTMLVideoElement>)}
				/>
			)
			break
	}

	if (content === null) {
		return null
	}

	return (
		<ClickWrapper
			whileTap={{
				scale: 0.99,
			}}
			onClick={onClick as MouseEventHandler<HTMLDivElement>}
		>
			<Attachment
				isLoading={status === AttachmentStatus.UPLOADING}
				isFailed={status === AttachmentStatus.UPLOAD_FAILED}
				key={data.id}
				onClose={onDelete}
				onRetry={onRetry}
			>
				<div className={styles.container}>{content}</div>
			</Attachment>
		</ClickWrapper>
	)
}
